import { useNavigate } from 'react-router-dom'

import { Box, Button, Variants as ButtonVariants } from '@factorialco/deprecated-design-system'
import { F0Button, F0ButtonProps } from '@factorialco/f0-react'
import { Upload } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { InsightTableType } from 'modules/finance/components/FinancialWorkspace/types/table'

type TypeBasedOnVersion<V> = V extends 'factorial-one' ? ButtonVariants : F0ButtonProps['variant']

interface Props {
  source: string
  version?: 'factorial-one' | 'factorial'
  textButton?: string
  type?: TypeBasedOnVersion<Props['version']>
  includeButtonIcon?: boolean
  onFinish?: () => void
  extraButtonProps?: Record<string, unknown>
}

export const UploadPayrollButton = ({
  source,
  textButton,
  type = 'default',
  version = 'factorial-one',
  includeButtonIcon,
  extraButtonProps,
}: Props) => {
  const factorialOneVersion = version === 'factorial-one'
  const { insightTableType } = useFinancialWorkspace()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const NAVIGATION_PATHS: Record<InsightTableType, string> = {
    [InsightTableType.EmployeeCosts]:
      navigation.finance.financialWorkspace.employee_costs.import_result.fullPath() +
      `?source=${InsightTableType.EmployeeCosts}`,
    [InsightTableType.Compensation]:
      navigation.finance.financialWorkspace.compensations.import_result.fullPath() +
      `?source=${InsightTableType.Compensation}`,
    [InsightTableType.Payroll]:
      navigation.finance.financialWorkspace.payroll.import_result.fullPath() +
      `?source=${InsightTableType.Payroll}`,
  }

  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()

  const openModal = () => {
    track(trackingEvents.payroll.initImportPayrollSummaryFromExternal, {
      companyId: currentCompanyId,
      source,
    })
    goToImportResult()
  }

  const goToImportResult = () => {
    const path = NAVIGATION_PATHS[insightTableType]
    navigate(path)
  }

  return (
    <Box data-testid="payroll-summary-import-button">
      {factorialOneVersion && (
        <F0Button
          onClick={() => openModal()}
          variant={'default'}
          icon={includeButtonIcon ? Upload : undefined}
          label={
            textButton || i18n.t('payroll_bundle.payroll_summary_import.button.default_button_text')
          }
        />
      )}

      {!factorialOneVersion && (
        <Button
          onClick={() => openModal()}
          type={type}
          iconName={includeButtonIcon ? 'upload' : undefined}
          extra={extraButtonProps}
        >
          {textButton || i18n.t('payroll_bundle.payroll_summary_import.button.default_button_text')}
        </Button>
      )}
    </Box>
  )
}
